import ApiService from "@/services/ApiService";
import CommonService from "@/services/CommonService";
export default {
  getAreaCountryAvailable() {
    const currentLanguage = CommonService.currentLanguage().split('_')[0];
    return ApiService().get(`/countries/available/${currentLanguage}`);
  },
  getAreaCountryAll() {
    return ApiService().get("/countries/all");
  },
  getCountryBySlug(slug) {
    return ApiService().get(`/countries/${slug}`);
  },
  getZoneBySlug(slug) {
    return ApiService().get(`/zones/${slug}`);
  },
  getTopGolfCourse({
    page = 1,
    limit = 10,
    sort = "desc",
    sortParam = "point",
    country,
    zone,
  }) {
    let baseUrl = `/courses?page=${page}&limit=${limit}&sort_${sort}=${sortParam}`;
    if (country) {
      baseUrl += `&filter_country=${country.id}`;
    }
    if (zone) {
      baseUrl += `&filter_zoneId=${zone.id}`;
    }
    return ApiService().get(baseUrl, false, false);
  },
  getHomepage() {
    return ApiService().get("/home");
  },
  searchGolfCourses({
    page = 1,
    limit = 10,
    sort = "desc",
    sortParam = "point",
    value,
    countryId,
    cityId,
    stateId
  }) {
    let baseUrl = `/courses?page=${page}&limit=${limit}&sort_${sort}=${sortParam}`;
    if (countryId) {
      baseUrl += `&countryId=${countryId}`;
    }
    if (value) {
      baseUrl += `&filter_name_like=${value}`;
    }
    if (cityId) {
      baseUrl += `&filter_city=${cityId}`;
    }
    if (stateId) {
      baseUrl += `&filter_state=${stateId}`;
    }
    return ApiService().get(baseUrl);
  },
  searchUser({
    page = 1,
    limit = 10,
    sort = "desc",
    value,
    countryId,
  }) {
    let baseUrl = `/users?page=${page}&limit=${limit}`;
    // if (countryId) {
    //   baseUrl += `&countryId=${countryId}`;
    // }
    if (value) {
      baseUrl += `&filter_name_like=${value}`;
    }
    return ApiService().get(baseUrl);
  },
  getCourseById(id) {
    return ApiService().get(`/courses/${id}`);
  },
  requestAdminGolfCourse(data) {
    return ApiService().post(`/courses/request-admin`, data, true);
  },
  getCourseReviewLanguage(id) {
    return ApiService().get(`/posts/languages?filter_course=${id}&distinct_relation=language&sort_desc=createdDate&filter_type[]=4`);
  },
  getCourseReview(id, page = 1, limit = 10, lang = 0) {
    let url = `/courses/review?filter_course=${id}&filter_type=${4}&page=${page}&limit=${limit}&sort_desc=createdDate`;
    if (lang != 0) url += `&filter_language=${lang}`
    return ApiService().get(url);
  },
  getAllReview(page = 1, limit = 10, lang = 0) {
    let url = `/courses/review?page=${page}&filter_type=${4}&limit=${limit}&sort_desc=createdDate`;
    if (lang != 0) url += `&filter_language=${lang}`
    return ApiService().get(url);
  },
  getCourseReviewTotal(id) {
    return ApiService().get(`/courses/review/info?filter_course=${id}`);
  },
  newCourseReview(data) {
    return ApiService().post("/courses/review", data, true);
  },
  deleteCourseReview(key) {
    return ApiService().delete(`/courses/review/${key}`);
  },
  updateCourseReview(data) {
    return ApiService().post(`/courses/review/${data.id}`, data);
  },
  updateInterview(data) {
    return ApiService().post("/courses/director-interview", data, true);
  },
  getInterview(id) {
    return ApiService().get(`/courses/director-interview/${id}`);
  },
  getCoursePlayer({
    page = 1,
    filter_user = null
  }) {
    let url = `courses-played?page=${page}`;
    if (filter_user) url = url + '&filter_user=' + filter_user
    return ApiService().get(url);
  },
  addCoursePlayer(data) {
    return ApiService().post(`courses-played/${data.id}`, undefined, true);
  },
  deleteCoursePlayer(data) {
    return ApiService().delete(`courses-played/${data.id}`);
  },
  updateInfoCourse(data) {
    return ApiService().post("/courses/edit", data, true);
  },
  addCoursePeers(data) {
    return ApiService().post("/course-peer", data, true);
  },
  updateCoursePeers(data) {
    return ApiService().put("/course-peer", data, true);
  },
  getListGolfCourseLocation(countryCode) {
    return ApiService().get(`/courses/country-map/${countryCode}`, true);
  }
};